
const mybody = document.body;
const saison = localStorage.getItem("saison");

if (saison === null) {
    localStorage.setItem("saison", "été");
}
if (saison === "hiver") {
    mybody.classList.add("hiver");
}
else {
    mybody.classList.remove("hiver");
}



class EntryManager {
  /**
   * @param {HTMLElement} rootEl 
   */
  constructor(rootEl) {
    this.getHTMLElements(rootEl);
    this.initCarousel(rootEl);
  }

  /**
   * @param {HTMLElement} rootEl 
   */
  getHTMLElements = (rootEl) => {
    this.rootEl = rootEl;
    this.entries = rootEl.querySelectorAll('.entries > .entry');
    // this.backgroundImages = rootEl.querySelectorAll('.background > img');
    this.carousel = jQuery(rootEl.querySelector('.owl-carousel'));
  }


  initCarousel = (rootEl) => {
    this.carousel.owlCarousel({
      loop: true,
      autoplay: false,
      // autoplaySpeed: 1500,
      // autoplayTimeout: 10000,
      dots: false,
      nav: true,
      navText: ['<i class="fa-regular fa-angle-left"></i>', '<i class="fa-regular fa-angle-right"></i>'],
      margin: 0,
      autoplayHoverPause: true,
      center: true,
      startPosition: 1,
      onTranslated: this.updateActiveEntry,
      items: 1,
      responsive: {
        0: {
          stagePadding: 25,
          items: 1,
        },
        768: {
          stagePadding: 50,
          items: 1,
        },
        1200: {
          // stagePadding: 250,
          items: 3,
        },
        1400: {
          // stagePadding: 350,
          items: 3,
        }
      }, 
      onInitialized : function(){



        const btnhiver = rootEl.querySelectorAll(".btnhiver");
        const btnete = rootEl.querySelectorAll(".btnete");
        





        btnhiver.forEach(function (userItem) {
          userItem.addEventListener("click", (event) => {

              if(!mybody.classList.contains('hiver')){
                  mybody.classList.add("hiver");
                  localStorage.setItem("saison", "hiver");
                  if (typeof (slider) !== "undefined") {
                  slider.updateSlider("95%", true);
                  }
              }
          });
        });
      
      
      
        btnete.forEach(function (userItem) {
          userItem.addEventListener("click", (event) => {
          if(mybody.classList.contains('hiver')){
              mybody.classList.remove("hiver");
              localStorage.setItem("saison", "été");
              if (typeof (slider) !== "undefined") {
              slider.updateSlider("5%", true);
          }
          }
      });
      });


      }
    });

    // currentcarousel


  }

  updateActiveEntry = () => {
    // const activeEntry = this.rootEl.querySelector('.owl-item.active .entry');

    // if (activeEntry?.dataset.entry) {
    //   this.toggleBackground(activeEntry.dataset.entry);
    // }
  }

  toggleBackground = id => {
    // this.backgroundImages.forEach(img => {
    //   if (img.dataset.entry === id) {
    //     img.classList.add('active')
    //   } else {
    //     img.classList.remove('active')
    //   }
    // })
  }
}


jQuery(document).ready(function () {
  const entriesBlocks = document.querySelectorAll('.wp-block-plune-blocks-slider-gammes');

  entriesBlocks.forEach(el => {
    new EntryManager(el);
  });
});
